import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const microsoftTeams = defineConnector({
  identifier: "microsoftTeams",
  name: "Microsoft Teams",
  tagLine: "Team collaboration and messaging",
  logo,
  protocol: "http",
  tags: ["featured", "communication", "productivity"],
  defaultUrlPattern: () => "https://graph\\.microsoft\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Connect your Microsoft Teams account",
      items: [
        {
          kind: "oauth",
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () =>
      "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
    tokenEndpoint: () =>
      "https://login.microsoftonline.com/common/oauth2/v2.0/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "env",
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://graph.microsoft.com/v1.0/me",
  },
});
